<template>
    <div class="warpper padding-sm">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="input-form ">
            <div class="page-title line-height">组织信息</div>
            <el-form-item ref="morglogo" label="组织LOGO" prop="morglogo" class="form-row-item flex align-center margin-tb-sm">
                <el-upload
                    class="avatar-uploader margin-left"
                    :action="`${ONLINEHOST_EMOF}home/User/imgthumb`"
                    :data="fileData"
                    :name="'image'"
                    :show-file-list="false"
                    accept="image/*"
                    :on-success="handleAvatarSuccess"
                    :disabled="readonly">
                    <div class="flex align-center">
                        <el-image class="logo " :src="ruleForm.morglogo" v-if="ruleForm.morglogo"></el-image>
                        <div class="logo up" v-else>+</div>
                        <div class="el-upload__tip margin-left" slot="tip">推荐尺寸大小120px*120px,5M以内</div>
                    </div>
                </el-upload>
            </el-form-item>
            <el-form-item label="组织二维码" class="form-row-item flex align-center margin-tb-sm">
               <div class="flex align-center">
                   <div class="org-scan" id="scan" ref="scan">
                       <qrcode :size="1000"
                               style="zoom:.1;"
                               :margin="5"
                               :logoSrc="`${scan_logo}`"
                               :text="qrcodeUrl">
                       </qrcode>
                   </div>
                   <div class="info-container margin-lr-sm">
                       <div class="info-content flex align-center" style="width: fit-content">
                           <div class="content">{{ qrcodeUrl }}</div>
                           <div class="operate" @click="copy">复制链接</div>
                       </div>
                   </div>
               </div>
            </el-form-item>
            <div class="page-title line-height">微信账号</div>
            <div class="info-container flex align-center margin-top-xs">
                <div class="info-content flex align-center">
                    <i class="iconfont icon-wx"></i>
                    <div class="content flex-sub">{{ wx_name || '未绑定微信账号' }}</div>
                    <div class="operate flex-shrink" v-if="wx_name" @click="showUnBindWx">解绑</div>
                    <a href="https://open.weixin.qq.com/connect/qrconnect?appid=wx2f662cfbfdc8da48&redirect_uri=https://hygl.emof.cn/vw/organization/organ/info&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'"
                       class="operate flex-shrink" v-else>绑定</a>
                </div>
            </div>
            <div class="page-title margin-tb-sm">基本信息</div>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgname" label="组织名称" prop="morgname" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.morgname" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="contacts" label="联系人" prop="contacts" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.contacts" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgtel" label="联系电话" prop="morgtel" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.morgtel" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="address" label="组织地址" prop="address" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.address" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item ref="morgemail" label="邮箱" prop="morgemail" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.morgemail" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item ref="morgurl" label="网址" prop="morgurl" labelWidth="100px" class="input-container">
                        <el-input v-model="ruleForm.morgurl" placeholder="请输入" :disabled="readonly"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <div class="page-title margin-tb-sm">组织介绍</div>

            <el-form-item ref="morgdesc" label="组织介绍" labelWidth="90px" class="margin-bottom-sm" prop="morgdesc">
                <div class="input-container padding-xs">
                    <div class="morgdesc" v-show="readonly" v-html="ruleForm.morgdesc"></div>
                    <VueUditorWrap v-model="ruleForm.morgdesc" :config="myConfig" v-show="!readonly"></VueUditorWrap>
                </div>
            </el-form-item>
            <div class="flex align-center justify-center margin-tb">
                <el-button type="primary" @click="submitForm('ruleForm')" class="input-form-btn"
                           :loading="loading">提交
                </el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils/utils"
import rules from "@/utils/rules";
import {bindWx, getParentInfo, setParentInfo, unBindWx} from '@/api/organiz'
// import {baseURL} from "@/config";
import {img_url} from "@/utils/const";
import {getQueryString} from "../../../../utils/utils";
import Qrcode from 'vue-qr'
import {HOSTPATH, ONLINEHOST_EMOF} from "@/config";
import {getFileBlob} from "@/api/login";

export default {
    name: "info",
    data() {
        return {
            ONLINEHOST_EMOF: ONLINEHOST_EMOF,
            myConfig: bdEditConfig(),
            baseURL: img_url,
            readonly: false,
            ruleForm: {
                morglogo: '',
                morgname: '',
                contacts: '',
                morgtel: '',
                address: '',
                morgemail: '',
                morgurl: '',
                morgdesc: '',
            },
            rules: {
                morglogo: [{required: true, message: "请上传组织LOGO", trigger: "change"}],
                morgname: [
                    {required: true, message: '请输入组织名称', trigger: 'blur'}
                ],
                contacts: [
                    {required: true, message: '请输入联系人', trigger: 'blur'}
                ],
                morgtel: rules.tel,
                address: [
                    {required: true, message: '请输入地址', trigger: 'blur'}
                ],
                morgemail: [
                    {required: true, message: '请输入邮箱地址', trigger: 'blur'},
                    {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
                ],
                morgurl: [
                    rules.webUrl
                ],
                morgdesc: [
                    {required: true, message: '请输入组织介绍', trigger: 'blur'}
                ],

            },
            loading: false,
            qrcodeUrl: '',
            scan_logo: '',
            wx_code: '',
            wx_name: ''
        }
    },
    computed: {
        fileData() {
            return {
                mid: this.$store.state.user.emofUserTokenSafer
            }
        },
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [5, 0], '组织信息')
        this.init()
        this.qrcodeUrl = `${HOSTPATH}login?mid=${this.user.mid}`
        this.wx_code = getQueryString('code')
        if (this.wx_code) {
            this.bindWx()
        }
    },
    components: {VueUditorWrap, Qrcode},
    methods: {
        async init() {
            let _data = await getParentInfo()
            if (_data.status === 200) {
                this.wx_name = _data.data.wx_name
                this.ruleForm = {
                    morglogo: _data.data.morglogo,
                    morgname: _data.data.morgname,
                    contacts: _data.data.contacts,
                    morgtel: _data.data.morgtel,
                    address: _data.data.address,
                    morgemail: _data.data.morgemail,
                    morgurl: _data.data.morgurl,
                    morgdesc: _data.data.morgdesc,
                }
                this.getFileBlob()
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid, validates) => {
                if (valid) {
                    this.submitChange();
                } else {
                    let error = Object.values(validates).shift().shift()
                    let dom = this.$refs[error.field]
                    this.$confirm(error.message, "提示", {
                        confirmButtonText: "确定",
                        showCancelButton: false,
                        type: "warning",
                    }).then(() => {
                        dom.$el.scrollIntoView({
                            block: 'center', // 当前元素显示在视图区域中间
                            behavior: 'auto' // 滚动速度
                        })
                    })
                }
            });
        },
        async submitChange() {
            this.loading = true
            let _data = await setParentInfo(this.ruleForm.morglogo, this.ruleForm.morgname,
                this.ruleForm.contacts, this.ruleForm.morgtel, this.ruleForm.address,
                this.ruleForm.morgemail, this.ruleForm.morgurl, this.ruleForm.morgdesc)
            this.loading = false
            if (_data.status === 200) {
                this.$store.state.user.morgurl = this.ruleForm.morgurl
                this.$store.state.user.morglogo = this.ruleForm.morglogo
                this.$store.state.user.morgname = this.ruleForm.morgname
                await window.localStorage.setItem('user', JSON.stringify(this.$store.state.user))
                await this.$store.commit('setUserInfo', this.$store.state.user)
                this.$message.success('提交成功')
                // this.$emit('upUserInfo')
                this.getFileBlob()

            }
        },
        handleAvatarSuccess(res) {
            if (res.status === 200) {
                this.ruleForm.morglogo = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        async getFileBlob() {
            let _data = await getFileBlob(this.ruleForm.morglogo)
            var reader = new FileReader();
            reader.readAsDataURL(_data.data);
            let _this = this
            reader.onload = function (e) {
                _this.scan_logo = e.target.result
            }
        },
        async bindWx() {
            let _data = await bindWx(this.user.account, this.wx_code)
            history.pushState('', '', window.location.origin + window.location.pathname)
            if (_data.status === 200) {
                this.wx_name = _data.data
                this.$message.success(_data.msg)
            } else {
                this.$message.error(_data.msg)
            }
        }
        ,
        showUnBindWx() {
            this.$confirm('您确定要解除微信绑定吗？', '提醒', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.unBindWx()
            })
        }
        ,
        async unBindWx() {
            let _data = await unBindWx(this.user.account)
            if (_data.status === 200) {
                this.wx_name = ''
                this.$message.success(_data.msg)
                this.init()
            } else {
                this.$message.error(_data.msg)
            }
        },
        // 复制地址
        copy() {
            let oInput = document.createElement('input')
            oInput.value = this.qrcodeUrl
            document.body.appendChild(oInput)
            oInput.select() // 选择对象
            document.execCommand("Copy") // 执行浏览器复制命令
            oInput.className = 'oInput'
            oInput.style.display = 'none'
            this.$message({
                message: '复制网址成功',
                type: 'success'
            })
        },
    }
    ,
    filters: {}
    ,
    watch: {}
    ,
}
</script>

<style scoped lang="scss">
.warpper {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 20px 30px;

    .logo {
        width: 80px;
        height: 80px;
        border-radius: 80px;

        &:hover {
            border: 1px dotted #fc7802;
        }

        &.up {
            border: 1px dotted #999999;
            line-height: 60px;
            text-align: center;
        }
    }

    .morgdesc {
        border-radius: 10px;
        border: solid 1px #dae0e6;
        padding: 12px;
    }

    .input-form-btn {
        width: 200px;
        height: 40px;
        line-height: 40px;
        border-radius: 40px;
        font-size: 16px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#ff9600, #ff9600);
        background-blend-mode: normal, normal;
        color: #ffffff;
        margin-top: 20px;
        padding: 0;

        &.white {
            background: #ffffff none;
            color: #ff9600;
        }
    }
}

.info-container {
    .info-tip {
        width: 62px;
        color: #0a2240;
        font-weight: bold;
    }

    .info-content {
        width: 354px;
        height: 50px;
        background-color: #f3f7fb;
        border-radius: 10px;
        border: solid 1px #d1deef;
        padding: 0 12px;

        i {
            width: 18px;
            height: 18px;
            line-height: 18px;
            border-radius: 18px;
            color: #9fdda3;
            background-color: #eeeeee;
            text-align: center;
            margin-right: 12px;
        }

        .content {
            font-size: 14px;
            color: #94a8c6;
        }

        .operate {
            font-size: 14px;
            font-weight: bold;
            color: #0a2240;
            margin-left: 20px;
            cursor: pointer;
        }
    }
}

.org-scan {

}
</style>